<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__update-time-left"
  >
    <template #pic>
      <icon
        data="@icon/clock.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        class="notification__update-time-left__icon"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        The time on these Tasks haven't been updated in quite some time
      </BaseSubHeading>
    </template>
    <template #content>
      <div
        v-for="(item, index) in notification?.items"
        :key="index"
        class="notification__update-time-left__item"
      >
        <div class="notification__update-time-left__item__header">
          <a
            class="is-small-400 notification__update-time-left__item__number"
            target="_blank"
            :href="item?.url ?? '#'"
          >
            #{{ item.sequenceNumber }}
          </a>
          <BaseSubHeading
            size="medium"
            weight="500"
            class="is-ellipsis"
          >
            {{ item.title }}
          </BaseSubHeading>
        </div>
        <div
          v-for="(task, key) in item?.tasks"
          :key="key"
          className="notification__update-time-left__task"
        >
          <BaseSubHeading
            size="medium"
            weight="500"
            class="notification__update-time-left__task__number"
          >
            {{ task.order }}
          </BaseSubHeading>
          <BaseSubHeading
            size="medium"
            color="monochrome-06"
            darkColor="monochrome-03"
            weight="400"
            class="is-ellipsis notification__update-time-left__task__name"
          >
            {{ task.name }}
          </BaseSubHeading>
          <BaseSubHeading
            size="small"
            weight="500"
            className="notification__update-time-left__task__estimation"
          >
            {{ task.estimatedHours }} hr
          </BaseSubHeading>
        </div>
      </div>
      <router-link
        v-if="$route.params.accountId"
        :to="{
          name: 'myWork'
        }"
        target="_blank"
        class="link is-large notification__update-time-left__view-my-work"
      >
        View My Work
      </router-link>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItem } from "@/models/Notification/NotificationItem"

@Options({
  name: "UPDATE_STORY_TIME_LEFT_REMINDER",
  components: {
    NotificationTemplate
  }
})
export default class UPDATE_STORY_TIME_LEFT_REMINDER extends Vue {
  @Prop() readonly notification: NotificationItem
}
</script>
